import { Component } from 'react';

import {
  MenuItem,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { connect } from 'react-redux';
import _ from 'lodash';

import Question from '../comps/Question';
import { getArchivedQuestions } from '../../../services/apiService';

class ArchivedQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,

      // filter options
      filterByDifficulty: '',
      filterByModule: '',
      filterByCompetency: '',
      filterByConcept: '',
      filterBySearch: '',
    };
  }

  componentDidMount = () => {
    const loadData = async () => {
      try {
        this.setState({
          questions: await getArchivedQuestions(),
          loading: false,
        });
      } catch (e) {
        console.error(e);
        this.setState({
          errorMessage: 'Failed to load questions, Please try again later!',
        });
      }
    };

    loadData();
  };

  render() {
    if (this.state.loading) {
      return (
        <div className='flex py-32 bg-white'>
          {this.state.errorMessage ? (
            <span className='m-auto text-red-500 text-center whitespace-pre-line'>
              {this.state.errorMessage}
            </span>
          ) : (
            <CircularProgress className='m-auto' />
          )}
        </div>
      );
    }

    // filter questions
    let questions = this.state.questions;
    let competencies, concepts;
    if (!this.state.loading) {
      if (this.state.filterByDifficulty)
        questions = _.filter(questions, {
          difficultyLevel: this.state.filterByDifficulty,
        });
      if (this.state.filterByConcept)
        questions = _.filter(questions, {
          conceptId: this.state.filterByConcept,
        });
      if (this.state.filterByCompetency) {
        questions = _.filter(
          questions,
          ({ conceptId }) =>
            this.state.filterByCompetency ===
            this.props.competencyIdByConceptId[conceptId]
        );
        concepts = _.filter(this.props.concepts, {
          competencyId: this.state.filterByCompetency,
        });
      }
      if (this.state.filterByModule) {
        questions = _.filter(
          questions,
          ({ conceptId }) =>
            this.state.filterByModule ===
            this.props.moduleIdByConceptId[conceptId]
        );
        competencies = _.filter(this.props.competencies, {
          moduleId: this.state.filterByModule,
        });
      }
      if (this.state.filterBySearch.length > 2)
        questions = _.filter(questions, ({ question }) =>
          question
            .toLowerCase()
            .includes(this.state.filterBySearch.toLowerCase())
        );
    }

    return (
      <div>
        <div className='bg-white pt-6'>
          <div>
            <div className='flex gap-2 justify-between items-center px-4'>
              <span className='text-gray-500 mx-2'>
                Total Items: {this.state.questions.length}
              </span>
              <span className='w-1/2 pl-2'>
                <TextField
                  onChange={({ target }) =>
                    this.setState({ filterBySearch: target.value })
                  }
                  type='text'
                  value={this.state.filterBySearch}
                  placeholder='Search Question'
                  variant='outlined'
                  size='small'
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Search className='text-gray-400' />
                      </InputAdornment>
                    ),
                  }}
                />
              </span>
            </div>

            {/* Filter Options */}
            <div className='flex gap-2 my-4 px-4'>
              <TextField
                select
                onChange={({ target }) =>
                  this.setState({ filterByDifficulty: target.value })
                }
                value={this.state.filterByDifficulty}
                label='Difficulty Level'
                variant='outlined'
                size='small'
                fullWidth
              >
                <MenuItem value=''>
                  <em>All</em>
                </MenuItem>
                <MenuItem value='easy'>Easy</MenuItem>
                <MenuItem value='medium'>Medium</MenuItem>
                <MenuItem value='hard'>Hard</MenuItem>
              </TextField>

              <TextField
                select
                onChange={({ target }) =>
                  this.setState({ filterByModule: target.value })
                }
                value={this.state.filterByModule}
                label='Module (L1)'
                variant='outlined'
                size='small'
                fullWidth
              >
                <MenuItem value=''>
                  <em>All</em>
                </MenuItem>
                {this.props.modules.map((mdl) => (
                  <MenuItem value={mdl.id} key={mdl.id}>
                    {mdl.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                onChange={({ target }) =>
                  this.setState({ filterByCompetency: target.value })
                }
                value={this.state.filterByCompetency}
                label='Competency (L2)'
                variant='outlined'
                size='small'
                fullWidth
              >
                <MenuItem value=''>
                  <em>All</em>
                </MenuItem>
                {(competencies || this.props.competencies).map((cmp) => (
                  <MenuItem value={cmp.id} key={cmp.id}>
                    {cmp.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                onChange={({ target }) =>
                  this.setState({ filterByConcept: target.value })
                }
                value={this.state.filterByConcept}
                label='Concept (L3)'
                variant='outlined'
                size='small'
                fullWidth
              >
                <MenuItem value=''>
                  <em>All</em>
                </MenuItem>
                {(concepts || this.props.concepts).map((cpt) => (
                  <MenuItem value={cpt.id} key={cpt.id}>
                    {cpt.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {/* Question List */}
            <div className='flex flex-col divide-y divide-gray-300'>
              {questions.map((ques, index) => (
                <Question
                  ques={ques}
                  updateList={this.componentDidMount}
                  index={index}
                  key={ques.id}
                />
              ))}
            </div>
            {this.state?.questions?.length === 0 && (
              <div className='py-32 text-center'>
                <h6 className='text-2xl font-semibold opacity-60 tracking-wider'>
                  Archive is Empty!
                </h6>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ questionLevelsReducer }) => ({
  ...questionLevelsReducer,
});

export default connect(mapStateToProps)(ArchivedQuestions);
